import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "@/requests/profile";
import { createSignal, onMount } from "solid-js";

export default function useUpdateProfile() {
  const [loading, setLoading] = createSignal(false);
  const [titleOptions, setTitleOptions] = createSignal([]);
  const [photo, setPhoto] = createSignal(null);
  const [form, setForm] = createStore({
    email: "",
    username: "",
    password: "",
    roleName: "",
    name: "",
    shortName: "",
    birthDate: Date.now(),
    photoURL: "",
    title: "",
    gender: "",
  });

  const { successToast, errorToast } = useApplication();

  const setupTitleOptions = (gender) => {
    if (gender === 'Male') {
      setTitleOptions([
        { value: '', text: '', disabled: false },
        { value: 'Mr.', text: 'Mr.', disabled: false },
        { value: 'Dr.', text: 'Dr.', disabled: false },
        { value: 'Engr.', text: 'Engr.', disabled: false }
      ]);

      return;
    }

    if (gender === 'Female') {
      setTitleOptions([
        { value: '', text: '', disabled: false },
        { value: 'Ms.', text: 'Ms.', disabled: false },
        { value: 'Mrs.', text: 'Mrs.', disabled: false },
        { value: 'Dr.', text: 'Dr.', disabled: false },
        { value: 'Engr.', text: 'Engr.', disabled: false }
      ]);

      return;
    }

    setTitleOptions([
      { value: '', text: '', disabled: false },
      { value: 'Dr.', text: 'Dr.', disabled: false },
      { value: 'Engr.', text: 'Engr.', disabled: false }
    ]);
  };

  onMount(async () => {
    try {
      await fetchUserProfile();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  });

  const fetchUserProfile = async () => {
    setLoading(true);
    try {
      const data = await get();
      setForm('email', data.user.email);
      setForm('username', data.user.username);
      setForm('password', "XXXXXX");
      setForm('roleName', data.user.roleName);
      setForm('name', data.user.name);
      setForm('shortName', data.user.shortName);
      setForm('title', data.user.title);
      setForm('gender', data.user.gender);
      setForm('birthDate', data.user.birthDate);
      setForm('photoURL', data.user.photoURL);
      setupTitleOptions(form.gender);
    } catch (error) {
      throw error;
    }
  }

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm(name, value);
  };

  const handlePhotoChange = (p) => {
    setPhoto(p);
  }

  const handleProfileUpdate = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {

      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, form[key]));
      formData.append('photo', photo());

      const data = await save(formData);

      successToast(data.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    form,
    titleOptions,
    handleProfileUpdate,
    handleInput,
    handleChange,
    handlePhotoChange,
  };
}
